import React from 'react'

export default function TabletOutline({ color = '#525150', style = {} }) {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
            <path
                d='M12.0003 1.33334H4.00033C3.26395 1.33334 2.66699 1.9303 2.66699 2.66668V13.3333C2.66699 14.0697 3.26395 14.6667 4.00033 14.6667H12.0003C12.7367 14.6667 13.3337 14.0697 13.3337 13.3333V2.66668C13.3337 1.9303 12.7367 1.33334 12.0003 1.33334Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M8 12H8.00667' stroke={color} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}
